import EventEmitter from "eventemitter3";
import {Power4, Sine, TimelineMax, TweenMax} from "gsap";
import VideoPlayer from "./Videoplayer";
// import introVideo from './assets/videos/01_Start_Loop.mp4'

export default class Intro extends EventEmitter {

    constructor(viewport) {
        super();

        this.viewport = viewport;
        this.timer = null;

        // Initialise intro button (replay)
        $$('#intro_btn').once('click', () => {
            this.hideControls(() => {
                this.removeEvents();
                // Show white logo
                TweenMax.to('#logo_white', 1, {delay: 0.5, display: 'block', alpha: 1})
                // Start the actual app
                this.emit('action');
            })
        });

        // Initialise Video #mainVideo
        // a. start and loop initial video 01 , show button and wait for interaction
        // 01_Start_Loop
        this.mainVideo = new VideoPlayer(viewport, null, 'intro', {
            autoplay: false, // !
            skip: null
        });

        // Intro button (WHY TRICORE)
        TweenMax.set('#intro_btn', {alpha: 1, 'display': 'initial', y: this.viewport.height * 1.1})

        $$('#video_intro').css('z-index','1');  // Show this one.

        // Listen for the video to be ready
        this.mainVideo.on('video:ready', () => {
            this.emit('ready');
        });

        // Listen for the video to end
        this.mainVideo.on('video:ended', () => {
            // Init next video
            this.emit('ended')
            // Show controls
            this.showControls();
            // Presentation mode only (TODO: make a setting)
            // this.timer = setTimeout(() => {
            //     this.hideControls(()=>{this.mainVideo.restart()})
            // }, 15000)
        })


    }

    /**
     * If no autoplay, then manually trigger
     *
     */
    play() {
        this.mainVideo.play();
    }

    showControls() {
        let tl = new TimelineMax()
        tl
            .set('#intro_btn', {alpha: 1, 'display': 'initial', y: this.viewport.height * 1.1})
            .to('#intro_btn', 2, {y: 0, ease: Sine.easeOut})

            // .to('#intro_btn span', 0.6, {alpha: 1, letterSpacing: 1, ease: Power4.easeInOut}, "-=1")
            .set('#svg_btn_bg', {stroke: "#FFFFFF", strokeWidth: '8', strokeDasharray: '200 3000'})
            .to('#svg_btn_bg', 1.7, {strokeDashoffset: 4000})
            .to('#svg_btn_bg', 2, {strokeDashoffset: 0, strokeDasharray: '6000 3000'}, "-=1")
            .to('#svg_btn_bg', 0.1, {fill: '#FFFFFF'}, "-=2")
            .to('#bgpulse', 0.3, {alpha: 1})
    }

    hideControls(callback) {
        TweenMax.to('#intro_btn', 1,
            {
                alpha: 0,
                "display": "none",
                ease: Power4.easeOut,
                onComplete: () => {
                    // callback()
                }
            });
        callback()
    }

    removeEvents() {
        this.mainVideo.off('video:ended');
        clearInterval(this.timer);
        this.timer = null;

    }

}
